import React, { useRef, useState, useMemo } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { getVersionData } from "@redux/version/selector";
import ScrollerArrowButton from "@icoach/inbody/components/ScrollerArrowButton";
import { Box } from "@curves/ui-base";
import InBodyInterviewMeasureCompareBox from "@icoach/inbody/components/InBodyInterviewMeasureCompareBox";
import { isEqual } from "@util/utils";

const MeasureCompareTable = ({ className, sourceData = [], measureItems = [] }) => {
	const reduxVersion = useSelector(getVersionData);
	let { env: ENV = "" } = reduxVersion;

	const [selectedItem, setSelectedItem] = useState(1);

	const divRef = useRef(null);

	// 提供對象的量身日 option
	const measureDateOptions = useMemo(
		() => {
			let opts = sourceData.map(({ measureDate }, index) => ({
				text: measureDate,
				value: index,
			}));
			opts.shift();
			return opts;
		},
		// eslint-disable-next-line
		[sourceData]
	);
	return (
		<Box className={clsx("inbody-measure inbody-measure-compare scroll-arrow-container", className)}>
			<Box className="container" ref={divRef}>
				{measureItems.map(({ value, key, rowClass, formatCell, formatCompare, formatMultipleCell, compareHidden = false, style: styleProps = {}, env }) => {
					if ((env && !env.some(x => isEqual(x, String(ENV).toUpperCase()))) || compareHidden) {
						return null;
					}
					let styles = { ...styleProps };
					return (
						// row
						<Box key={value} className={clsx("row", rowClass, sourceData.length === 0 && "full-width")} style={{ ...styles }}>
							{/* Column 標題 */}
							<Box className={clsx("item", "sticky", "label")} style={{ width: "180px" }}>
								{value}
							</Box>
							{/*比較內容*/}
							<InBodyInterviewMeasureCompareBox
								datumData={sourceData[0]}
								compareData={sourceData[selectedItem]}
								measureDateOptions={measureDateOptions}
								itemKey={key}
								formatCell={formatCell}
								formatCompare={formatCompare}
								formatMultipleCell={formatMultipleCell}
								selectedItem={selectedItem}
								setSelectedItem={setSelectedItem}
								styles={styles}
							/>
							{/*<InBodyExtendDiv />;*/}
						</Box>
					);
				})}
			</Box>
			<ScrollerArrowButton arrowLeftPos={600} parentRef={divRef} />
		</Box>
	);
};

export default MeasureCompareTable;
